export const CanReferMixin = {
  computed: {
    isImpersonating() {
      return !!this.authUser?.isImpersonated;
    },
    canReferInsideEstate() {
      return this.isClearWill;
    },
    canRefer() {
      if (this.isImpersonating) {
        return false;
      }

      if (!this.isInsideEstate) {
        return false;
      }

      return this.canReferInsideEstate;
    }
  }
};
